import { useId } from 'react';

interface FlagIconProps {
    lang: string;
    /** Höhe in px; Breite folgt dem Seitenverhältnis der jeweiligen Flagge. */
    height?: number;
    className?: string;
}

// Inline-SVG-Flaggen statt Flaggen-Emoji. Grund: Windows rendert Regional-Indicator-Emoji (🇩🇪/🇬🇧)
// NICHT als Flagge, sondern als Buchstabenkürzel ("DE"/"GB") - Segoe UI Emoji enthält bewusst keine
// Länderflaggen. Diese SVGs sehen auf allen Plattformen identisch aus. Neue Sprache = hier einen
// weiteren Zweig ergänzen.
export const FlagIcon = ({ lang, height = 14, className }: FlagIconProps) => {
    // useId liefert Doppelpunkte (":r0:"), die in url(#...) unschön sind - entfernen.
    const uid = 'flag-' + useId().replace(/:/g, '');

    const wrap = (aspect: number, svg: JSX.Element) => (
        <span
            className={className}
            aria-hidden="true"
            style={{
                display: 'inline-block',
                height,
                width: Math.round(height * aspect),
                borderRadius: 2,
                overflow: 'hidden',
                // feiner Rahmen, damit helle Flaggenkanten (Weiß/Gold) auf jedem Untergrund sichtbar bleiben
                boxShadow: '0 0 0 1px rgba(0,0,0,0.15)',
                flexShrink: 0,
                lineHeight: 0,
            }}
        >
            {svg}
        </span>
    );

    if (lang === 'de') {
        return wrap(5 / 3, (
            <svg width="100%" height="100%" viewBox="0 0 5 3" preserveAspectRatio="none">
                <rect width="5" height="3" fill="#000000" />
                <rect y="1" width="5" height="1" fill="#DD0000" />
                <rect y="2" width="5" height="1" fill="#FFCE00" />
            </svg>
        ));
    }

    if (lang === 'en') {
        // Kompakter Union Jack (kanonische SVG-Variante). Der Clip-Path versetzt die roten
        // Diagonalen korrekt; die id muss pro Instanz eindeutig sein (mehrfach auf einer Seite).
        return wrap(2, (
            <svg width="100%" height="100%" viewBox="0 0 60 30" preserveAspectRatio="none">
                <clipPath id={uid}>
                    <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
                </clipPath>
                <rect width="60" height="30" fill="#012169" />
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#ffffff" strokeWidth="6" />
                <path d="M0,0 L60,30 M60,0 L0,30" clipPath={`url(#${uid})`} stroke="#C8102E" strokeWidth="4" />
                <path d="M30,0 v30 M0,15 h60" stroke="#ffffff" strokeWidth="10" />
                <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
            </svg>
        ));
    }

    return null;
};
